import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { fmtDate } from "../../../format";
import type { MaintenanceWebhookSubscription } from "../../../types";

interface WebhooksCardProps {
  loading: boolean;
  webhooks: MaintenanceWebhookSubscription[];
  newWebhookUrl: string;
  setNewWebhookUrl: (value: string) => void;
  onCreateWebhook: () => void;
}

export function WebhooksCard({
  loading,
  webhooks,
  newWebhookUrl,
  setNewWebhookUrl,
  onCreateWebhook,
}: WebhooksCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>Maintenance Webhook Configurations</Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1} sx={{ mb: 2 }}>
          <TextField
            label="Webhook Target URL"
            value={newWebhookUrl}
            onChange={(e) => setNewWebhookUrl(e.target.value)}
            fullWidth
          />
          <Button variant="contained" onClick={onCreateWebhook} disabled={!newWebhookUrl.trim()}>
            Add Webhook
          </Button>
        </Stack>
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
            <CircularProgress size={24} />
          </Box>
        )}
        {!loading && webhooks.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No maintenance webhooks configured.
          </Typography>
        )}
        {!loading && webhooks.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Target URL</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Updated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {webhooks.map((webhook) => (
                <TableRow key={webhook.id}>
                  <TableCell sx={{ wordBreak: "break-all" }}>{webhook.target_url}</TableCell>
                  <TableCell>
                    <Chip
                      label={webhook.is_active ? "Active" : "Inactive"}
                      color={webhook.is_active ? "success" : "default"}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{fmtDate(webhook.created_at)}</TableCell>
                  <TableCell>{fmtDate(webhook.updated_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
